import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'UniformAuthService',
    controller: 'OrgProduct'
}
const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GetItemById',
    'FindByConditions',
    'GetPageContentByConditions',
    'GetProductIdsByOrgId'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const OrgProductApi = ZJApi.defineNewApi('OrgProductApi', factory)

export default OrgProductApi